import ScheduleList from './list.es6';
import ScheduleDetail from './detail.es6';

export default class Main{

    constructor() {
        this.init();
    }

    init(){

        if(document.body.classList.contains('-list')){
            this.schedulelist = new ScheduleList();
        }
        else{
            this.scheduledetail = new ScheduleDetail();
        }
    }
}
